export const SOULS_IN_HIT = 1000000000;
export const HIT_STRING_KEY = 'J3Pxz64r9L3pWKhDfNZ2uQ2y25r1W8hcnrQmMJtR6NCp';

export const createUint8Array = (stringKey: string) =>
  Uint8Array.from(stringKey.split(',').map((number) => parseInt(number)));
